export default [
  {
    path: '/equipment/maintain',
    name: 'maintain',
    meta: {
      title: '设备远程信息管理'
    },
    component: () =>
      import(/* webpackChunkName: "data" */ '@/views/equipment/information/index.vue')
  },
  {
    path: '/equipment/maintain/imgAdd',
    name: 'imgAdd',
    meta: {
      title: '端口图片远程配置新增'
    },
    component: () =>
      import(/* webpackChunkName: "data" */ '@/views/equipment/information/imgAdd/index.vue')
  },
  {
    path: '/equipment/maintain/imgEdit',
    name: 'imgEdit',
    meta: {
      title: '端口图片远程怕配置修改'
    },
    component: () =>
      import(/* webpackChunkName: "data" */ '@/views/equipment/information/imgEdit/index.vue')
  },
  {
    path: '/equipment/control/onoff',
    name: 'onoff',
    meta: {
      title: '设备通断控制'
    },
    component: () =>
      import(/* webpackChunkName: "data" */ '@/views/equipment/onOff/index_new.vue')
  },
  // {
  //   path: '/aiTerminal/tereQuipment',
  //   name: 'tereQuipment',
  //   meta: {
  //     title: '终端设备升级'
  //   },
  //   component: () =>
  //     import(/* webpackChunkName: "data" */ '@/views/aiTerminal/tereQuipment.vue')
  // },
  // {
  //   path: '/aiTerminal/terminaList',
  //   name: 'terminaList',
  //   meta: {
  //     title: '设备升级列表'
  //   },
  //   component: () =>
  //     import(/* webpackChunkName: "data" */ '@/views/aiTerminal/terminaList.vue')
  // }
]
